import { getMod } from 'services/hooks';
import { getModComponent } from 'services/utils';

export const ModNotifications = () => {
  const BadGaugeNotificationMC = getModComponent(
    getMod('gauges')?.components.BadGaugeNotification
  );
  const GaugesEnergyNotificationMC = getModComponent(
    getMod('gaugesHard')?.components.GaugesEnergyNotification
  );
  const LifeGoalNotificationMC = getModComponent(
    getMod('lifeGoals')?.components.LifeGoalNotification
  );
  const DeductionNotificationMC = getModComponent(
    getMod('financial')?.containers.DeductionNotification
  );

  return (
    <>
      <BadGaugeNotificationMC />
      <GaugesEnergyNotificationMC />
      <LifeGoalNotificationMC />
      <DeductionNotificationMC />
    </>
  );
};
